import { MessageSchema } from "@redotech/redo-model/agents/llm-messages";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const getAskRedoThreadById = {
  name: "getAskRedoThreadById" as const,
  input: z.object({ threadId: zExt.objectId() }),
  output: z
    .object({
      _id: zExt.objectId(),
      agentName: z.string(),
      versionedAgentId: zExt.objectId().nullish(),
      team: zExt.objectId(),
      parentThreadId: zExt.objectId().nullish(),
      messages: z.array(MessageSchema),
      pendingTools: z.array(
        z.object({
          id: z.string(),
          toolName: z.string(),
          args: z.unknown(),
          confirmed: createEnum([
            "confirmed",
            "pending",
            "not_required",
          ]).nullish(),
          confirmationData: z.unknown().nullish(),
          confirmationPrompt: z.string().nullish(),
        }),
      ),
      state: z.unknown(),
      output: z.unknown().optional(),
      iterationCount: z.number(),
      createdAt: z.date(),
      updatedAt: z.date(),
      intercomConversationId: z.string().nullish(),
    })
    .nullish(),
};
